'use strict';

module.exports = function () {
	try {
		Object.keys('primitive');
		return true;
	} catch (e) { return false; }
};



//////////////////
// WEBPACK FOOTER
// ./~/event-emitter/~/es5-ext/object/keys/is-implemented.js
// module id = 21
// module chunks = 0